import { render, staticRenderFns } from "./ChatToggleButton.vue?vue&type=template&id=63f3592c&scoped=true"
import script from "./ChatToggleButton.vue?vue&type=script&lang=js"
export * from "./ChatToggleButton.vue?vue&type=script&lang=js"
import style0 from "./ChatToggleButton.vue?vue&type=style&index=0&id=63f3592c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3592c",
  null
  
)

export default component.exports